import React from "react";
import BankAccountType from "../Payment/BankAccountType";

const PlanAccountType = () => {
  return (
    <React.Fragment>
      <div className="plan_account_type">
        <BankAccountType path/>
      </div>
    </React.Fragment>
  );
};

export default PlanAccountType;
